












import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import { DateTime } from 'luxon';
import { EnumDocumentType } from '@getaccept/lib-shared/src/enums/DocumentType';
import type { DashboardExpiringDocument } from '../../../types/dashboard-expiring-document';

export default defineComponent({
  name: 'ExpiringSoonWidgetItem',
  props: {
    document: {
      type: Object as PropType<DashboardExpiringDocument>,
      required: true,
    },
  },
  setup(props) {
    const to = `/document/view/${props.document.id}`;

    const date = computed(() =>
      DateTime.fromISO(props.document.expirationDate).toLocaleString({
        hour: '2-digit',
        day: 'numeric',
        year: 'numeric',
        month: 'numeric',
        minute: '2-digit',
      })
    );

    const icon = computed(() => {
      switch (props.document.type) {
        case EnumDocumentType.Sales:
          return `document-${EnumDocumentType.Sales}`;
        case EnumDocumentType.Hr:
          return `document-${EnumDocumentType.Hr}`;
        case EnumDocumentType.Introduction:
        case EnumDocumentType.Presentation:
          return `document-${EnumDocumentType.Presentation}`;
        case EnumDocumentType.Other:
        default:
          return `document-${EnumDocumentType.Other}`;
      }
    });

    return { to, date, icon };
  },
});
